import React from 'react';
import store from '../../store/Store';
import actions from '../../actions/Actions';

import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'

import FormatItalicIcon from '@material-ui/icons/FormatItalic'
import FormatBoldIcon from '@material-ui/icons/FormatBold'
import DoneIcon from '@material-ui/icons/Done'
import EditIcon from '@material-ui/icons/Edit'
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined'
import SlideshowIcon from '@material-ui/icons/Slideshow'
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation'
import VideoLabelIcon from '@material-ui/icons/VideoLabel'
import YouTubeIcon from '@material-ui/icons/YouTube'
import PublishIcon from '@material-ui/icons/Publish'

import './editorMediaVideo.scss'

type editorMediaVideoState = {
  article: any;
  navigation: any;
  row: any;
  column: any;
  youtube: any;
  upload: any;
  id: any;
}

type editorMediaVideoProps = {
  article: any;
  navigation: any;
  row: any;
  column: any;
  id: any;
}

class EditorMediaVideo extends React.Component<editorMediaVideoProps, editorMediaVideoState> {

  constructor(props) {
    super(props)

    this.state = {
      article: props.article,
      navigation: props.navigation,
      row: props.row,
      column: props.column,
      youtube: false,
      upload: false,
      id: props.id
    }
  }

  componentDidMount() {
    store.subscribe(() => {
      this.setState({
        article: store.getState().article,
        navigation: store.getState().navigation
      })
    })
  }

  onClick = (event) => {
    // console.log('Clicked')
  }

  onDragEnter = (event) => {
    // console.log('DRAG ENTER')

    // console.log(event)

    event.preventDefault()
    event.stopPropagation()
  }

  onDragLeave = (event) => {
    // console.log('DRAG LEAVE')

    // console.log(event)

    event.preventDefault()
    event.stopPropagation()
  }

  onDragOver = (event) => {
    // console.log('DRAG OVER')

    // console.log(event)

    event.preventDefault()
    event.stopPropagation()
  }

  onDrop = (event) => {
    // console.log('DROP')

    // console.log(event)
    // console.log(event.currentTarget)
    // console.log(event.currentTarget)
    // console.log(event.target)
    // console.log(event.target.id)
    // console.log(event.target.files)
    // console.log(event.currentTarget)
    // console.log(event.dataTransfer.files)
    // console.log(event.dataTransfer)

    let targetId = event.target.id

    // console.log(targetId)

    event && event.dataTransfer && event.dataTransfer.files ? this.uploadVideo(event.dataTransfer.files[0]) : this.uploadVideo(event.target.files[0])

    // event.target.files ? console.log('File was opened') : console.log('File was NOT opened')
    // event && event.dataTransfer && event.dataTransfer.files ? console.log('File was dragged') : console.log('File was NOT dragged')

    event.preventDefault()
    event.stopPropagation()

    let reader = new FileReader()
    event && event.dataTransfer && event.dataTransfer.files ? reader.readAsDataURL(event.dataTransfer.files[0]) : reader.readAsDataURL(event.target.files[0])
    reader.onloadend = function() {
      let img = document.createElement('img')
      img.src = reader.result as string

      // console.log(img)

      img.style.width = '100%'
      img.style.height = '100%'
      document.getElementById(targetId).appendChild(img)
    }
  }

  uploadVideo = (image) => {
    // console.log(image)

    const { row, column, article, id } = this.state

    const formData = new FormData()

    formData.append('image', image)
    formData.append('imageName', image.name)
    formData.append('imageSize', image.size)
    formData.append('imageType', image.type)

    // console.log(formData.getAll('image'))

    let link

    actions.uploadActions.uploadImage(formData).then((res) => {
      // console.log(res)
      // console.log(res.success)
      // console.log(res.returnCode)
      // console.log(res.returnMessage)
      // console.log(res.imageLink)

      actions.articleActions.updateMedia({
        index: article.info.currentPage,
        row, 
        column,
        type: 1,
        id,
        content: {
          link: res.imageLink
        }
      })
    }).catch((err) => { 
      console.log(err) 
    })
  }

  onChangeIndex = (selectedPage, lastPage) => {
    actions.editorActions.setEditorSelectedPage(selectedPage)
    actions.editorActions.setEditorPreviousPage(lastPage)
  }

  onChangeYouTube = (event) => {
    const { row, column, id, article } = this.state

    console.log(event.target.value)

    let link = event.target.value
    link = link.replace('watch?v=', 'embed/')

    console.log(link)

    actions.articleActions.updateMedia({
      index: article.info.currentPage,
      row, 
      column,
      type: 2,
      id,
      content: {
        link,
        autoPlay: false,
        origin: 'YouTube',
        creator: ''
      }
    })
  }

  onYouTube = () => {
    console.log('YouTube Clicked')

    this.setState({
      youtube: !this.state.youtube
    })
  }

  onUpload = () => {
    console.log('Upload Clicked')

    this.setState({
      upload: !this.state.upload
    })
  }

  render() {
    const {
      article,
      navigation,
      row,
      column,
      youtube,
      upload
    } = this.state

    // console.log(youtube)

    let edit = false
    let preview = false
    let link
    let autoPlay = true

    article.pages.map((page, index, array) => {
      article.info.currentPage === page.index && page.edit && page.edit.map((item, index, array) => {
        return item.row === row && item.column === column ? edit = true : null
      })

      article.info.currentPage === page.index && page.preview && page.preview.map((item, index, array) => {
        return item.row === row && item.column === column ? preview = true : null
      })

      article.info.currentPage === page.index && (page.edit || page.preview) && page.media.map((item, index, array) => {
        return item.row === row && item.column === column ? link = item.content && item.content.link ? item.content.link : '' : null
      })
    })

    // console.log('EditorMediaVideo')
    // console.log(edit)
    // console.log(preview)

    console.log(link)

    let ap = autoPlay ? '1' : '0'
    let mute = 1
    link = link + '?autoplay=' + ap + '&mute=' + mute

    console.log(link)    

    return (
      <div
        className='EditorMediaVideo'
        style={{
          width: '100%',
          height: '100%'
        }}
      >
        
        {
          edit && !article.preview ? (
            <div
              style={{
                position: 'absolute',
                width: '100%',
                maxWidth: '100%',
                height: '100%',
                maxHeight: '100%',
                margin: 0,
                padding: 0,
                overflow: 'hidden'
              }}
            >
              {
                upload ?
                  <div
                    style={{
                      position: 'absolute',
                      width: 'calc(100% - 20px)',
                      height: 'calc(100% - 20px)',
                      border: '1px dashed rgba(0, 0, 0, 255)',
                      margin: '9px',
                      textAlign: 'center',
                      color: 'rgba(0, 0, 0, 255)'
                    }}
                    onDragEnter={ this.onDragEnter.bind(this) }
                    onDragLeave={ this.onDragLeave.bind(this) }
                    onDragOver={ this.onDragOver.bind(this) }
                    onDrop={ this.onDrop.bind(this) }
                  >
                    <div
                      style={{
                        display: 'block',
                        position: 'absolute',
                        width: '120px',
                        height: '50px',
                        top: 'calc(50% - 25px)',
                        left: 'calc(50% - 60px)',
                        lineHeight: '50px',
                        cursor: 'pointer',
                        border: '1px dotted rgba(0, 0, 0, 255)'
                      }}
                      onClick={ this.onClick.bind(this) }
                    >
                      Drag 'N' Drop
                    </div>

                    <input 
                      type='file'
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        opacity: 0,
                        width: '100%',
                        height: '100%',
                        cursor: 'pointer'
                      }}
                      onChange={ this.onDrop.bind(this) }
                    />
                  </div>
                : youtube ?
                  <div
                    style={{
                      position: 'relative',
                      width: '100%',
                      height: '100%',
                      minWidth: '100%',
                      minHeight: '100%',
                      maxWidth: '100%',
                      maxHeight: '100%',
                      textAlign: 'center',
                      backgroundColor: 'rgba(150, 150, 150, 255)'
                    }}
                  >
                    <div
                      style={{
                        display: 'block',
                        position: 'absolute',
                        width: '150px',
                        height: '50px',
                        top: 'calc(50% - 15px)',
                        left: 'calc(50% - 75px)'
                      }}
                    >
                      <input 
                        style={{ maxWidth: '150px' }} 
                        placeholder={'YouTube Link'}
                        onChange={ (event) => { this.onChangeYouTube(event) }}
                      />
                    </div>
                  </div>
                :
                  <div
                    style={{
                      position: 'relative',
                      width: '100%',
                      height: '100%',
                      minWidth: '100%',
                      minHeight: '100%',
                      maxWidth: '100%',
                      maxHeight: '100%',
                      textAlign: 'center',
                      backgroundColor: 'rgba(150, 150, 150, 255)'
                    }}
                  >
                    <div
                      style={{
                        display: 'block',
                        position: 'absolute',
                        width: '150px',
                        height: '50px',
                        top: 'calc(50% - 75px)',
                        left: 'calc(50% - 75px)'
                      }}
                    >
                      <IconButton
                        edge={ 'end' }
                        className={ 'MenuButton' }
                        color="inherit" 
                        aria-label="menu"
                        onClick={ () => {
                          actions.articleActions.addPreviewCell({
                            index: article.info.currentPage,
                            row,
                            column
                          })
                        }}
                      >
                        <Icon>
                          <VideoLabelIcon />
                        </Icon>
                      </IconButton>
                    </div>

                    <div
                      style={{
                        display: 'block',
                        position: 'absolute',
                        width: '150px',
                        height: '50px',
                        top: 'calc(50% - 25px)',
                        left: 'calc(50% - 75px)'
                      }}
                    >
                      <IconButton
                        edge={ 'end' }
                        className={ 'MenuButton' }
                        color="inherit" 
                        aria-label="menu"
                        onClick={ () => {
                          this.onYouTube()
                        }}
                      >
                        <Icon>
                          <YouTubeIcon />
                        </Icon>
                      </IconButton>

                      <IconButton
                        edge={ 'end' }
                        className={ 'MenuButton' }
                        color="inherit" 
                        aria-label="menu"
                        onClick={ () => {
                          this.onUpload()
                        }}
                      >
                        <Icon>
                          <PublishIcon />
                        </Icon>
                      </IconButton>

                      <IconButton
                        edge={ 'end' }
                        className={ 'MenuButton' }
                        color="inherit" 
                        aria-label="menu"
                        onClick={ () => {
                          actions.articleActions.removeMedia({
                            index: article.info.currentPage,
                            row,
                            column
                          })
                        }}
                      >
                        <Icon>
                          <DeleteForeverOutlinedIcon />
                        </Icon>
                      </IconButton>
                    </div>
                  </div>
              }

              <IconButton
                style={{
                  position: 'absolute',
                  bottom: '0',
                  right: '0'
                }}
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={ () => { this.setState({
                    youtube: false,
                    upload: false
                  })
                  actions.articleActions.removeEditCell({
                    index: article.info.currentPage,
                    row,
                    column
                  }) 
                }}
              >
                <Icon>
                  <DoneIcon />
                </Icon>
              </IconButton>
            </div>
          ) : preview || article.preview ? (
            <div
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                minWidth: '100%',
                minHeight: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                textAlign: 'center'
              }}
            >
              <iframe 
                src={ link }
                width={ '100%' }
                height={ '100%' }
                style={{
                  border: 0,
                  maxWidth: '100%',
                  maxHeight: '100%'
                }}
              ></iframe>

              <IconButton
                style={{
                  position: 'absolute',
                  bottom: '0',
                  right: '0'
                }}
                edge={ 'end' }
                className={ 'MenuButton' }
                color="inherit" 
                aria-label="menu"
                onClick={ () => { actions.articleActions.removePreviewCell({
                    index: article.info.currentPage,
                    row,
                    column
                  }) 
                }}
              >
                <Icon>
                  <CancelPresentationIcon />
                </Icon>
              </IconButton>
            </div>
          ) : (
            <div
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                minWidth: '100%',
                minHeight: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                textAlign: 'center',
                backgroundColor: 'rgba(150, 150, 150, 255)'
              }}
            >
              <div
                style={{
                  display: 'block',
                  position: 'absolute',
                  width: '150px',
                  height: '50px',
                  top: 'calc(50% - 75px)',
                  left: 'calc(50% - 75px)'
                }}
              >
                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => {
                    actions.articleActions.addPreviewCell({
                      index: article.info.currentPage,
                      row,
                      column
                    })
                  }}
                >
                  <Icon>
                    <VideoLabelIcon />
                  </Icon>
                </IconButton>
              </div>

              <div
                style={{
                  display: 'block',
                  position: 'absolute',
                  width: '150px',
                  height: '50px',
                  top: 'calc(50% - 25px)',
                  left: 'calc(50% - 75px)'
                }}
              >
                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => {
                    actions.articleActions.addPreviewCell({
                      index: article.info.currentPage,
                      row,
                      column
                    })
                  }}
                >
                  <Icon>
                    <SlideshowIcon />
                  </Icon>
                </IconButton>

                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => {
                    actions.articleActions.addEditCell({
                      index: article.info.currentPage,
                      row,
                      column
                    })
                  }}
                >
                  <Icon>
                    <EditIcon />
                  </Icon>
                </IconButton>

                <IconButton
                  edge={ 'end' }
                  className={ 'MenuButton' }
                  color="inherit" 
                  aria-label="menu"
                  onClick={ () => {
                    actions.articleActions.removeMedia({
                      index: article.info.currentPage,
                      row,
                      column
                    })
                  }}
                >
                  <Icon>
                    <DeleteForeverOutlinedIcon />
                  </Icon>
                </IconButton>
              </div>
            </div>
          )
        }

      </div>
    );
  }
}

export default EditorMediaVideo;